import React, { useEffect } from 'react';
import { View, Image, StyleSheet, Dimensions, Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { MAIN_PAGES } from './menu';
import ChargerStation from '../pages/ChargerStation';
import ChargerSelection from '../pages/ChargerSelection';
import ChargerValidation from '../pages/ChargerValidation';
import RegisterUpdateCharger from '../pages/RegisterUpdateCharger';
import MyChargers from '../pages/MyChargers';
import DatePicker from './DatePicker';
import ChargingScreen from '../pages/ChargingScreen';
import ChargeSummary from '../pages/ChargeSummary';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
// MyAccount screen removed - using SideMenu drawer navigation instead
import AccountInfo from '../pages/AccountInfo';
import PayoutRules from '../pages/PayoutRules';
import TransactionHistory from '../pages/TransactionHistory';
import CreateAccount from '../pages/CreateAccount';
import LoginWithAccount from '../pages/LoginWithAccount';
// @ts-ignore - Platform-specific file (.native/.web)
import WelcomeScreen from '../pages/WelcomeScreen';
// import SplashScreenNew from '../pages/SplashScreenNew';
// Footer removed - using SideMenu drawer navigation instead
// import { ChargerAttributes } from '../models/charger-model';
import LoginScreen from '../pages/login';
import ManageCharger from '../pages/ManageCharger';
// import { ChargerHistoryAttributes } from '../models/charger-history-model';
import ChargerScanHandler from './common/ChargerScanHandler';
// import { OrderAttributes } from '../models/order-model';
import { routeTitleMap } from './common/utils/route-title-map';
import ActiveChargeCard from '../pages/ActiveChargeCard';
// import { ActiveChargeAttributes } from '../models/active-charges-model';
import * as Location from 'expo-location';
import { ChargingStationNotFound } from '../pages/ChargingStationNotFound';
// import { ChargerSchedule } from '../store/actions/scheduling-actions';
// @ts-ignore - Platform-specific file (.native/.web)
import SetupBilling from '../pages/SetupBilling';
// For platform-specific files, import the module without extension; React Native resolver will pick .native or .web
// @ts-ignore - Platform-specific file (.native/.web)
import SetupBillingAddress from '../pages/SetupBillingAddress';
import OnboardingStatus from '../pages/OnboardingStatus';
import ResetPasswordPage from '../pages/reset-password.web';
import TestErrorNotifications from './TestErrorNotifications';
import PartnerPortal from '../pages/PartnerPortal';
// @ts-ignore - Platform-specific file (.native/.web)
import PartnerInsights from '../pages/PartnerInsights';
// @ts-ignore - Platform-specific file (.native/.web)
import HostInsights from '../pages/HostInsights';
import AdminScreen from '../pages/AdminScreen';
import RevenueSplitDashboard from '../pages/RevenueSplitDashboard';
// @ts-ignore - Platform-specific file (.native/.web)
import PartnerEarningsDashboard from '../pages/PartnerEarningsDashboard';
import SplitPartnerships from '../pages/SplitPartnerships';

const Tab = createBottomTabNavigator();

import type { RootStackParamList } from '../navigation/stackTypes';

const Stack = createNativeStackNavigator<RootStackParamList>();

const MeanderStack = ({ currentRouteName }: { currentRouteName: string }) => {
  return (
    <Stack.Navigator
      initialRouteName="WelcomeScreen"
      screenOptions={({ route }) => ({
        headerShown: false,
        contentStyle: { backgroundColor: '#1A1D21' },
        // Disable native back gesture on main pages (where edge swipe opens menu instead)
        // Only applies to iOS - Android uses hardware back button
        gestureEnabled: Platform.OS === 'ios' ? !MAIN_PAGES.includes(route.name) : true,
      })}
    >
      <Stack.Screen
        name="LoginScreen"
        component={LoginScreen}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="ChargerScan"
        component={ChargerScanHandler}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="ChargerStation"
        component={ChargerStation}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="ChargerSelection"
        component={ChargerSelection}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="ChargerValidation"
        component={ChargerValidation}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="RegisterUpdateCharger"
        component={RegisterUpdateCharger}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="MyChargers"
        component={MyChargers}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="DatePicker"
        component={DatePicker}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="ChargingScreen"
        component={ChargingScreen}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="ChargeSummary"
        component={ChargeSummary}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="AccountInfo"
        component={AccountInfo}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="PayoutRules"
        component={PayoutRules}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="PartnerPortal"
        component={PartnerPortal}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="PartnerInsights"
        component={PartnerInsights}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="HostInsights"
        component={HostInsights}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="RevenueSplitDashboard"
        component={RevenueSplitDashboard}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'Revenue Split Analytics',
        }}
      />
      <Stack.Screen
        name="PartnerEarningsDashboard"
        component={PartnerEarningsDashboard}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'Partner Earnings',
        }}
      />
      <Stack.Screen
        name="SplitPartnerships"
        component={SplitPartnerships}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'Split Partnerships',
        }}
      />
      <Stack.Screen
        name="AdminScreen"
        component={AdminScreen}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="TransactionHistory"
        component={TransactionHistory}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="CreateAccount"
        component={CreateAccount}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="LoginWithAccount"
        component={LoginWithAccount}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="WelcomeScreen"
        component={WelcomeScreen}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'Welcome to MeanderEV',
        }}
      />
      <Stack.Screen
        name="ManageChargers"
        component={ManageCharger}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen name="ActiveChargeCard" component={ActiveChargeCard} />
      <Stack.Screen
        name="ChargingStationNotFound"
        component={ChargingStationNotFound}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      {/* <Stack.Screen name="SplashScreenNew" component={SplashScreenNew} /> */}
      {/* Footer route removed - using SideMenu drawer navigation */}
      <Stack.Screen
        name="SetupBilling"
        component={SetupBilling}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="SetupBillingAddress"
        component={SetupBillingAddress}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="OnboardingStatus"
        component={OnboardingStatus}
        options={{
          title:
            currentRouteName && routeTitleMap[currentRouteName]
              ? routeTitleMap[currentRouteName].title
              : 'MeanderEV',
        }}
      />
      <Stack.Screen
        name="resetPassword"
        component={ResetPasswordPage}
        options={{
          title: 'Reset Password',
        }}
      />
      {/* Development Only - Test Error Notifications Screen */}
      {process.env.REACT_NATIVE_ENV === 'development' && (
        <Stack.Screen
          name="TestErrorNotifications"
          component={TestErrorNotifications}
          options={{
            title: 'Test Error Notifications',
          }}
        />
      )}
    </Stack.Navigator>
  );
};

export default MeanderStack;
